import { jsx as c, jsxs as W } from "react/jsx-runtime";
import b, { createContext as D, useContext as w, useState as L } from "react";
import { u as m } from "./index-6a632112.mjs";
import { Badge as P } from "./badge.js";
import { f as y, s as n, b as p, Q as C, r as v, d as R, e as S, a as g } from "./themes-5f0b3c3d.mjs";
import { l as T } from "./lineHeights-72d3110c.mjs";
const j = m.div`
  overflow: auto;
  max-width: 100%;
  width: ${({ $isBottomBorderFullWidth: e }) => e ? "100%" : "fit-content"};

  font-family: ${y.inter};
  display: flex;
  position: relative;
  ${({ $size: e }) => {
  switch (e) {
    case "large":
      return `height: ${n["12x"]};
                gap:${n["6x"]};`;
    case "medium":
      return `height: ${n["10x"]};
                gap:${n["5x"]};`;
    case "small":
      return `height:${n["8x"]};
                gap:${n["4x"]};`;
  }
}};
  border-bottom: ${({ $borderBottom: e, theme: o }) => e ? `${p["1x"]} solid ${o.components.tabs.tabBottomBorder}` : "none"};
  box-sizing: border-box;
  user-select: none;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  &::after {
    content: '';
    width: 10px;
    height: 100%;
  }

  @media ${C.tabletAndUp} {
    &::after {
      content: none;
    }
  }
`, H = m.div`
  position: relative;
  width: 100%;

  &::after {
    content: '';
    top: 0;
    border-radius: ${v["2x"]} ${v["2x"]} 0 0;
    right: 0;
    position: absolute;
    pointer-events: none;
    background-image: linear-gradient(
      to right,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 1) 100%
    );
    width: ${n["5x"]};
    height: 100%;
  }

  @media ${C.tabletAndUp} {
    background-image: none;
    &::after {
      content: none;
    }
  }
`, K = m.span`
  display: inline-flex;
  align-items: center;
  gap: ${n["1x"]};
  flex-shrink: 0;
  box-sizing: border-box;

  ${({ $size: e }) => {
  switch (e) {
    case "small":
      return `
          height:${n["8x"]};
          gap:${n["1x"]};
        `;
    case "large":
      return `
          height:${n["12x"]};
          gap:${n["2x"]};
        `;
    case "medium":
    default:
      return `
          height:${n["10x"]};
          gap:${n["2x"]};
        `;
  }
}}

  &:focus-visible {
    outline: ${({ $isDisabled: e, theme: o }) => !e && `${p["2x"]} solid ${o.components.tabs.tabFocusRing}`};
    border-radius: ${v["1x"]};
    outline-offset: 2px;
  }
`, O = m.span`
  text-align: center;
  font-family: ${R.body};
  font-style: normal;
  font-weight: ${S.medium.S.fontWeight};
  color: ${({ $isActive: e, $isDisabled: o, theme: t }) => o ? t.components.tabs.textDisabledColor : e ? t.components.tabs.textActiveColor : t.components.tabs.textDefaultColor};
  cursor: ${({ $isDisabled: e }) => e ? "not-allowed" : "pointer"};
  height: calc(100% - 2px);
  border-bottom: ${({ $isActive: e, theme: o, $isDisabled: t }) => e && !t ? `${p["2x"]} solid ${o.components.tabs.tabActiveBottomBorder};` : `${p["2x"]} solid transparent;`};
  display: flex;
  align-items: center;

  &:hover {
    ${({ $isActive: e, $isDisabled: o, theme: t }) => !o && `border-bottom: ${p["2x"]} solid ${e ? t.components.tabs.tabActiveBottomBorder : t.components.tabs.tabHoverBottomBorder};`}
  }
  ${({ $size: e }) => {
  switch (e) {
    case "small":
      return `
            font-size: ${g.xsmall};
            line-height: ${T.small};
        `;
    case "large":
      return `
            font-size: ${g.medium};
            line-height: ${T.large};
        `;
    case "medium":
    default:
      return `
          font-size: ${g.small};
          line-height: ${T.medium};
        `;
  }
}};
`, U = m.div`
  font-family: ${y.inter};
  display: flex;
  flex-direction: column;
`, N = m.div`
  font-family: ${y.inter};
  color: ${({ theme: e }) => e.components.tabs.textDefaultColor};
`, Q = m.div`
  display: flex;
  align-items: 'center';
  justify-content: 'center';
`, $ = D(void 0), Z = ({
  children: e,
  size: o = "medium",
  borderBottom: t = !0,
  isBottomBorderFullWidth: s = !1,
  badgeProp: i,
  activeTab: r = 0,
  setActiveTab: u
}) => {
  const l = {
    activeTabIndex: r,
    setActiveTabIndex: u,
    size: o,
    borderBottom: t,
    badgeProp: i,
    isBottomBorderFullWidth: s
  };
  return /* @__PURE__ */ c($.Provider, { value: l, children: e });
}, ee = ({ children: e, ...o }) => {
  const t = w($), [s, i] = L(!1);
  if (!t)
    throw new Error("TabList must be used within a Tabs component");
  const {
    activeTabIndex: r,
    setActiveTabIndex: u,
    size: l,
    borderBottom: h,
    isBottomBorderFullWidth: A
  } = t;
  return /* @__PURE__ */ c(H, { children: /* @__PURE__ */ c(
    j,
    {
      $size: l,
      role: "tablist",
      onKeyDown: (d) => {
        const f = b.Children.toArray(
          e
        ), x = f.length, z = x - 1 === r, k = r === 0, I = () => {
          setTimeout(() => {
            const B = document.querySelector(
              '[data-focus="true"] [aria-selected="true"]'
            );
            B && B.focus();
          }, 0);
        }, E = () => {
          for (a = k ? x - 1 : r - 1; f[a].props.isDisabled; )
            a = a === 0 ? x - 1 : a - 1;
        }, F = () => {
          for (a = z ? 0 : r + 1; f[a].props.isDisabled; )
            a = a === x - 1 ? 0 : a + 1;
        };
        let a = r;
        d.key === "ArrowLeft" && E(), d.key === "ArrowRight" && F(), a !== r && u(a), d.key !== "Tab" && I();
      },
      $borderBottom: h || !1,
      ...o,
      onFocus: () => i(!0),
      onBlur: () => i(!1),
      "data-focus": s,
      $isBottomBorderFullWidth: A || !1,
      children: (() => b.Children.map(e, (d, f) => b.isValidElement(d) ? b.cloneElement(d, { index: f }) : d))()
    }
  ) });
}, te = ({
  children: e,
  index: o,
  isDisabled: t = !1,
  ...s
}) => {
  const i = w($);
  if (!i)
    throw new Error("Tab must be used within a Tabs component");
  const { activeTabIndex: r, setActiveTabIndex: u, size: l, badgeProp: h } = i;
  return /* @__PURE__ */ W(
    K,
    {
      role: "tab",
      $size: l,
      $isActive: r === o,
      "aria-selected": r === o,
      onClick: () => {
        t || u(o);
      },
      tabIndex: !t && r === o ? 0 : void 0,
      $isDisabled: t,
      ...s,
      children: [
        /* @__PURE__ */ c(
          O,
          {
            $isActive: r === o,
            $isDisabled: t,
            $size: l,
            children: e
          }
        ),
        h && /* @__PURE__ */ c(Q, { children: /* @__PURE__ */ c(P, { size: l === "small" ? l : "medium", ...h }) })
      ]
    }
  );
}, oe = ({ children: e }) => /* @__PURE__ */ c(U, { role: "tabpanel", children: (() => b.Children.map(e, (t, s) => b.isValidElement(t) ? b.cloneElement(t, { index: s }) : t))() }), ne = ({ children: e, index: o, ...t }) => {
  const s = w($);
  if (!s)
    throw new Error("TabPanel must be used within a Tabs component");
  const { activeTabIndex: i } = s;
  return i === o ? /* @__PURE__ */ c(N, { role: "tabpanel", ...t, children: e }) : null;
};
export {
  te as Tab,
  ee as TabList,
  ne as TabPanel,
  oe as TabPanels,
  Z as Tabs
};
